let startTime = 0

export const usePerformanceTiming = () => {
  const onPerformanceCheckStart = () => {
    if (window._timingData) {
      startTime = performance.now()
    }
  }

  const onPerformanceCheckEnd = () => {
    if (window._timingData) {
      const endTime = performance.now()
      const navigationTime = endTime - startTime

      const timingData = {
        ...window._timingData,
        page_load_time: navigationTime,
      }

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'performance_timing',
        timing: timingData,
      })

      console.info(`[QIC-Analytics] Performance timing: ${navigationTime}ms`)
    }
  }

  return {
    onPerformanceCheckStart,
    onPerformanceCheckEnd,
  }
}
